export default "__VITE_ASSET__e11f44b6__"